import { useTheme } from '@mui/material/styles'
import Box from '@mui/material/Box'
import OutlinedInput from '@mui/material/OutlinedInput'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import Chip from '@mui/material/Chip'
import { useTranslate } from 'react-admin'
import { IconButton } from '@material-ui/core'
import { Clear } from '@mui/icons-material'

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
}

const options_const = [
  { id: 'oliver-hansen', label: 'Oliver Hansen' },
  { id: 'april-tucker', label: 'April Tucker' },
  { id: 'omar-olexander', label: 'Omar Alexander' },
]

function getStyles(item, vals, theme, idKey) {
  return {
    fontWeight: vals.find((val) => val[idKey] == item[idKey])
      ? theme.typography.fontWeightRegular
      : theme.typography.fontWeightMedium,
  }
}

export default function SelectChips({
  options = options_const,
  label = 'Options',
  labelKey = 'label',
  idKey = 'id',
  values,
  setValues,
}) {
  const theme = useTheme()
  const translate = useTranslate()
  const handleChange = (event) => {
    const {
      target: { value },
    } = event
    setValues(value)
  }

  return (
    <FormControl sx={{ m: 1, width: '100%' }}>
      <InputLabel id="multiple-chip-label">{label}</InputLabel>
      <Select
        labelId="multiple-chip-label"
        id="multiple-chip"
        multiple
        value={values}
        onChange={handleChange}
        input={<OutlinedInput id="select-multiple-chip" label={label} />}
        endAdornment={
          <IconButton
            style={{
              display: values.length ? '' : 'none',
              marginRight: '10px',
            }}
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()
              setValues([])
            }}
          >
            <Clear style={{ fontSize: '18px' }} />
          </IconButton>
        }
        renderValue={(selected) => {
          return (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
              {selected.map((value) => (
                <Chip
                  key={value[idKey]}
                  label={translate(value[labelKey], {
                    _: value[labelKey],
                  })}
                />
              ))}
            </Box>
          )
        }}
        MenuProps={MenuProps}
      >
        {options.map((item) => (
          <MenuItem
            key={item[idKey]}
            value={item}
            style={getStyles(item, values, theme, idKey)}
          >
            {translate(item[labelKey], {
              _: item[labelKey],
            })}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
